import { PATTERN_LABEL, useImageAnnotatorContext } from "@msuite/image-annotator";
import type { TranslationKey } from "@msuite/utils/locales";
import { fillPatterns } from "@msuite/utils/schemas";
import type { PolygonAnnotation } from "@msuite/utils/types";
import { useId } from "react";
import { useTranslation } from "../../../localization";
import { cn } from "../../../utils";
import { getPatternId, Pattern } from "../patterns";

const SIZE = 36;

export function AnnotationToolbarSubMenuPattern() {
	/** Context */
	const context = useImageAnnotatorContext();
	const selectedAnnotation = context.controller.getSelectedAnnotation() as PolygonAnnotation;

	/** Hooks */
	const salt = useId();
	const { t } = useTranslation();

	/** Guard */
	if (!selectedAnnotation) return null;

	/** Render */
	return (
		<div className="flex flex-row gap-3 overflow-x-auto">
			{fillPatterns.map((pattern) => (
				<button
					key={pattern}
					type="button"
					className="relative aspect-square shrink-0 rounded-full"
					style={{ width: SIZE }}
					title={t(PATTERN_LABEL[pattern] as TranslationKey)}
					aria-label={t(PATTERN_LABEL[pattern] as TranslationKey)}
					onClick={() => context.controller.handleOnUpdateSelection({ fillPattern: pattern })}
				>
					<svg
						width={SIZE}
						height={SIZE}
						aria-hidden="true"
					>
						<Pattern
							type={pattern}
							color="white"
							salt={salt}
						/>
						<circle
							cx={SIZE / 2}
							cy={SIZE / 2}
							r={SIZE / 2}
							fill={getPatternId(pattern, salt)}
						/>
					</svg>
					<div
						className={cn(
							"absolute inset-0 rounded-full border-2",
							pattern === selectedAnnotation.fillPattern
								? "border-yellow-500"
								: "border-primary-600",
						)}
					/>
				</button>
			))}
		</div>
	);
}
